import VueI18n from "vue-i18n";
import Vue from "vue";
import messages from "@/languages";

Vue.use(VueI18n);

let lang = localStorage.getItem("language");

// Verifica se Existe Language armazenado
if (lang == undefined) {
  let language = navigator.language;
  localStorage.setItem("language", language.slice(0, 2));
  lang = language.slice(0, 2);
}

if (lang != "es" || lang != "en" || lang != "pt") {
  lang = "en";
}

const i18n = new VueI18n({
  locale: localStorage.getItem("language") || "en", // set locale
  fallbackLocale: localStorage.getItem("language") || "en", // set fallback locale
  messages, // set locale messages
});

export default i18n;
